// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7603":"css/admin-app.6704","9746":"css/app.6704"}[chunkId] + ".css";
};